import styled, { css } from 'styled-components';

type CardStyleProps = {
  isLink: boolean;
};

export const CardStyle = styled.div<CardStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem;
  width: 100%;
  height: 150px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.UI_COLORS.primary};
  color: ${({ theme }) => theme.UI_COLORS.secondary};
  transition: box-shadow 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
  margin: 1rem;
  text-decoration: none;

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: ${({ isLink }) => (isLink ? 'pointer' : 'default')};
    ${({ isLink }) =>
      isLink &&
      css`
        box-shadow: inset 0 0 0 3px ${({ theme }) => theme.UI_COLORS.primary};
      `}
  }

  .icon {
    margin-left: 1rem;
  }
  .card-title {
    font-size: ${({ theme }) => theme.TYPOGRAPHY.h2.fontSize};
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    width: 300px;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;
